export const experiences = [
  {
    year: "2023 - Present",
    role: "Senior Full Stack Dev",
    company: "Future AI Labs",
    description: [
      "Building high-frequency AI-driven data visualization platforms.",
      "Optimized legacy Node.js backends for high concurrency and performance.",
      "Leading cross-functional design sprints for enterprise-scale UI/UX."
    ],
  },
  {
    year: "2021 - 2023",
    role: "Full Stack Developer",
    company: "Pixel Perfect Agency",
    description: [
      "Managed international healthcare client portals with modern React architecture.",
      "Implemented seamless CI/CD pipelines for zero-downtime deployments.",
      "Collaborated with product designers to create pixel-perfect digital experiences."
    ],
  },
  {
    year: "2020 - 2021",
    role: "MERN Stack Intern",
    company: "Innovate Hub",
    description: [
      "Assisted in the transition from monolithic to microservices backend.",
      "Built landing pages with focus on performance and SEO best practices.",
      "Fixed critical bugs in reporting tools for major e-commerce partners."
    ],
  },
  {
    year: "2016 - 2020",
    role: "Computer Science Graduate",
    company: "Leading Tech University",
    description: [
      "Achieved distinction in software design and algorithmic complexity.",
      "Captain of the University competitive programming club.",
      "Published a research paper on distributed systems and cloud optimization."
    ],
  },
];
